// extracted by mini-css-extract-plugin
export default {"wrapper":"ScrollTable__wrapper-nU3My","scroll":"ScrollTable__scroll-zFWbO","table":"ScrollTable__table-XXBiv","status":"ScrollTable__status-HsjMP"};